<template functional>
    <span 
        class="rounded text-white" 
        :class="[props.small ? 'font-size-60 font-weight-500' : 'font-size-80 font-weight-600', 'bg-' + props.variant, 'mx-' + props.xMargin]"
        style="padding: 2px 4px;"
    >{{props.text}}</span>
</template>

<script>

export default {
    functional: true,
    name: 'NewBadge',
    props: {
        text: {  // like "NEW"
            type: String,
            default: 'NEW',
        },
        variant: {  // like danger
            type: String,
            default: 'danger',
        },
        small: {  // you have 2 sizes:  'small' (true) and not small (false)
            type: Boolean,
            default: false,
        },
        xMargin: {
            type: [String, Number],
            default: '1',
        }
    },
}
</script>

<style>

</style>